/*
 *
 *  General Methods
 */

/**
 * Add Body Classes
 *
 * @param {Array} classNames
 */
export function addBodyClasses(classNames) {
  document.body.classList.add(...classNames)
}

/**
 * Remove Body Classes
 *
 * @param {Array} classNames
 */
export function removeBodyClasses(classNames) {
  document.body.classList.remove(...classNames)
}

/**
 * Check Data Values
 *
 * check if values exist in an object
 *
 * @export
 * @param {Object} data
 * @returns
 */
export function checkDataValues(data) {
  // check if object exist
  if (!data || data === 'null' || data === 'undefined') return false
  // init data
  const newData = {}
  // check the fields to add to newData
  Object.keys(data).forEach(key => {
    // check property
    if (data.hasOwnProperty(key)) {
      newData[key] = data[key]
    }
  })
  // log
  //console.log('checkDataValues newData thumb', newData.thumb)
  // check if data exist
  if (Object.keys(newData).length < 1) return false
  // return
  return newData
}

/**
 * Find Data Changes
 *
 * search and find data changes in object
 *
 * @export
 * @param {Object} oriData
 * @param {Object} data
 * @returns
 */
export function findDataChanges(oriData, data) {
  // check if objects exist
  if (!oriData || !data || oriData === 'null' || oriData === 'undefined' || data === 'null' || data === 'undefined')
    return false
  // init data
  const changes = {}
  // check the fields to add to changes
  Object.keys(data).forEach(key => {
    // check for changes
    if (oriData[key] !== data[key]) {
      changes[key] = data[key]
    }
  })
  // log
  //console.log('findDataChanges changes', changes)
  // check if changes exist
  if (Object.keys(changes).length < 1) return false
  // return
  return changes
}

/*
 *
 *  Custom Validation
 */

// check if values exist in an object
export function isValidUrl(str) {
  var pattern = new RegExp(
    '^(https?:\\/\\/)?' + // protocol
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
    '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
    '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
      '(\\#[-a-z\\d_]*)?$',
    'i'
  ) // fragment locator
  return !!pattern.test(str)
}

// search array by key
export function searchArrayByKey(arr, key, val) {
  for (var i = 0; i < arr.length; i++) {
    if (arr[i][key] === val) {
      return {
        key: i,
        array: arr[i]
      }
    }
  }
}

/**
 * Chunkify
 *
 * @export
 * @param {*} array
 * @param {number} [chunkSize=10]
 * @returns
 */
export function chunkify(array, chunkSize = 10) {
  // make a new array
  const chunks = Array.from(
    // give it however many slots are needed - in our case 8
    // 1-7 with 10 items, and 8th slot will have 6
    {
      length: Math.ceil(array.length / chunkSize)
    },
    // this is a map function that will fill up our slots
    (_, i) => {
      // make a slice of 100 items
      const start = chunkSize * i
      // slice our the piece of the array we need
      return array.slice(start, start + chunkSize)
    }
  )
  return chunks
}
